export default "__VITE_ASSET__Dn6CTdh5__"